import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { CodeList } from './codeList';
import { TrainingObj } from './trainingObj';
import { ViewportScroller } from '@angular/common';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { messageService } from '../message.service';
import { PaginationService } from '../PaginationService';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MsalService } from '@azure/msal-angular';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { AssignTrainingComponent } from '../tms/assign-training/assign-training.component';


@Component({
  selector: 'app-add-training',
  templateUrl: './add-training.component.html',
  styleUrls: ['./add-training.component.scss']
})
export class AddTrainingComponent implements OnInit {

  trainingData: TrainingObj = {};
  dropDownForCategories: any = [];
  dropDownForTrainingType: CodeList[] = [];
  dropDownForLanguage: CodeList[] = [];
  isFileValid = false;
  trainingImage: any;
  trainingImageToView: any;
  buttonLabels: string[] = [];
  saveButtonForTraining = false;
  instructions = "";
  stageName: any;
  actionStatusOptions: any;
  isProcessing = false;
  clearedTrainingImage = false;
  clearedOperationDoc = false;
  operationFlag: any;
  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;
  onClickedSaveButton: any = false;
  visibleAddTrainingButton: boolean;
  visibleEditTrainingButton: boolean;
  visibleReasonForTrainingUpdateField: boolean = false;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  isSelfAssignToggleBoxValue: boolean;

  selectedCategory: any = null;
  selectedTrainingType: any = null;
  selectedLanguage: any = null;
  selectedStatus: any = [];
  selectedReason: any = null;
  selectedRejectReason: any = null;

  categoryDropdown: any = [];
  trainingTypeDropdown: any = [];
  languageDropdown: any = [];
  statusDropdown: any = [];
  reasonDropdown: any = [];
  rejectReasonDropdown: any = [];

  previousTrainingData: any;

  categorySearchText: string = '';
  typeSearchText: string = '';
  languageSearchText: string = '';
  rejectReasonSearchText: string = '';
  reasonSearchText: string = '';

  oddCategory: any = null;
  oddType: any = null;
  oddLanguage: any = null;

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;
  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;
  visibleInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;

  showAssignTraining = false;
  @ViewChild('training') assignTrainingComponent!: AssignTrainingComponent;
  assignTraining() {
    this.showAssignTraining = true;
    setTimeout(() => {
      this.assignTrainingComponent?.openAddPopup();
      setTimeout(() => {
        this.assignTrainingComponent.selectedTrainingCriteria = 'One training → Multiple groups';
        this.assignTrainingComponent.training.trainingName = this.assignTrainingComponent.draftTraining.trainingName = this.trainingData.trainingName;
        this.assignTrainingComponent.draftTraining.version = this.trainingData.version;
        this.assignTrainingComponent.draftTraining.trainingId = this.trainingData.trainingId;
      });
    });
  }

  onTrainingPopupClosed() {
    this.showAssignTraining = false;
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  };

  infoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  InputVar: ElementRef;
  dateCustomClasses: DatepickerDateCustomClasses[];
  minDate: any;
  isAdEnabled: boolean = false;

  constructor(private readonly _formBuilder: FormBuilder, private readonly cd: ChangeDetectorRef, private readonly appService: AppService, private readonly router: Router, public dialog: MatDialog, private readonly scroller: ViewportScroller, private readonly snackBar: MatSnackBar, private readonly activatedRoute: ActivatedRoute,
    public message: messageService, public paginationService: PaginationService, private readonly authService: MsalService) {

    this.dropDownForCategories = this.appService.getCategoryData();
    this.trainingData = this.appService.getTrainingData();
    this.trainingData['module'] = "TRN";
    if (this.trainingData.description != null) {
      this.trainingData.description = "<div>" + this.trainingData.description + "</div>";
    }

    if (this.trainingData.expiryDate != null && this.trainingData.expiryDate != undefined) {
      if (new Date(this.trainingData.expiryDate) < new Date()) {
        this.minDate = new Date(this.trainingData.expiryDate);
      } else {
        this.minDate = new Date();
      }
    } else {
      this.minDate = new Date();
    }
    this.selectedTabIndex = this.message.sendBackToContent ? 1 : 0;
    if (this.selectedTabIndex == 1) this.message.sendBackToContent = false
  };

  orgData: any;

  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.message.isShowApplicableForAllCheckBox = false;

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })


    this.isAdEnabled = localStorage.getItem("adEnabled") == 'Y';

    this.activatedRoute.data.subscribe(({ trainingType }) => {
      this.dropDownForTrainingType = trainingType;
      this.trainingTypeDropdown = this.dropDownForTrainingType.map((type: any) => ({
        valueExp: type.codelistCode,
        displayExp: type.codelistName
      })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
    })

    this.activatedRoute.data.subscribe(({ languageForTraining }) => {
      this.dropDownForLanguage = languageForTraining;
      this.languageDropdown = this.dropDownForLanguage.map((type: any) => ({
        valueExp: type.codelistCode,
        displayExp: type.codelistName
      })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
    })

    this.categoryDropdown = this.dropDownForCategories.map((type: any) => ({
      valueExp: type.trainingCategoryCode,
      displayExp: type.trainingCategoryName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []

    this.trainingOperations();
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  displaytrainingImage: any = null;
  description: any;
  expDateOrDay: boolean;
  trainingOperations() {
    this.onClickedSaveButton = false;
    if (this.trainingData.trainingId == undefined) {
      this.trainingData['operation'] = "I"
      this.operationFlag = "ADD";
      this.visibleAddTrainingButton = true;
      this.visibleEditTrainingButton = false;
      this.saveButtonForTraining = true;
      this.trainingData['saveButtonForTraining'] = true;
      this.isSelfAssignToggleBoxValue = false;
      this.trainingData.selfAssignable1 = false;
      this.trainingData['trainingName'] = "";
      this.trainingData['trainingCode'] = "";
      this.trainingData['type'] = "";
      this.trainingData['categoryCode'] = "";
      this.trainingData['language'] = "";
      this.trainingData['description'] = "";
      this.trainingData['module'] = "TRN";
      this.trainingData['expiryInDays'] = null;
      this.expDateOrDay = false;
      this.trainingData['expiryDate'] = null;
      this.trainingData['meetingUrl'] = "";
    } else {
      this.message.breadcrumbData.thirdLevel = this.trainingData.trainingName + "(" + this.trainingData.trainingCode + ")";
      this.operationFlag = "EDIT";
      this.trainingData['module'] = "TRN";
      this.trainingData.updateReason = null;
      this.previousTrainingData = this.trainingData;
      this.visibleAddTrainingButton = false;
      this.visibleEditTrainingButton = true;
      delete this.trainingData['createdOn'];
      delete this.trainingData['updatedOn'];
      this.trainingData['operation'] = "U"
      this.description = this.trainingData.description;
      this.trainingImage = this.trainingData['trainingImage'];
      this.displaytrainingImage = this.trainingData['trainingImage'];
      this.selectedCategoryValue = this.trainingData['categoryCode'];
      this.selectedTrainingTypeValue = this.trainingData['type'];
      this.selectedLanguageValue = this.trainingData['language'];
      this.isSelfAssignToggleBoxValue = this.trainingData.selfAssignable == "Y";
      this.trainingData.selfAssignable1 = this.trainingData.selfAssignable == "Y";
      this.expDateOrDay = false;
      this.isShowDateField = false;
      if (this.trainingData['expiryDate'] != null) {
        this.trainingData['expiryDate'] = new Date(this.trainingData['expiryDate']);
        this.expDateOrDay = false;
        this.isShowDateField = true;
      }

      if (this.trainingData['expiryInDays'] != null) {
        this.expDateOrDay = true;
        this.isShowDateField = false;
      }

      if (this.trainingData.categoryCode) {
        const matchingCode = this.categoryDropdown?.find((item: any) => item.valueExp == this.trainingData.categoryCode);
        if (!matchingCode) {
          this.oddCategory = this.trainingData.categoryCode;
          this.categoryDropdown.push({
            valueExp: this.trainingData.categoryCode,
            displayExp: this.trainingData.categoryCode
          })
        }
        this.selectedCategory = this.trainingData.categoryCode;
      }

      if (this.trainingData.type) {
        const matchingType = this.trainingTypeDropdown?.find((item: any) => item.valueExp == this.trainingData.type);
        if (!matchingType) {
          this.oddType = this.trainingData.type;
          this.trainingTypeDropdown.push({
            valueExp: this.trainingData.type,
            displayExp: this.trainingData.type
          })
        }
        this.selectedTrainingType = this.trainingData.type;
      }

      if (this.trainingData.language) {
        const matchingLanguage = this.languageDropdown?.find((item: any) => item.valueExp == this.trainingData.language);
        if (!matchingLanguage) {
          this.oddLanguage = this.trainingData.language;
          this.languageDropdown.push({
            valueExp: this.trainingData.language,
            displayExp: this.trainingData.language
          })
        }
        this.selectedLanguage = this.trainingData.language;
      }

      this.appService.getTaskStages(this.trainingData['trainingId'], this.trainingData['version']).subscribe((data: any) => {
        this.taskStagesList = data;
        this.isProcessing = false;
      })

      this.saveButtonForTraining = false;
      this.trainingData['saveButtonForTraining'] = false;
      this.isProcessing = true;
      this.appService.getButtonLabels(this.trainingData['trainingId'], this.trainingData['version'],
        this.trainingData['status']).subscribe((data: any) => {
          this.isProcessing = false;
          this.stageName = data.stageName;
          this.actionStatusOptions = data.actionStatusOptions;
          this.instructions = data.instructions;
          if (data.buttonLabels != null) {
            this.buttonLabels = data.buttonLabels.split(",");
            for (let i = 0; i < this.buttonLabels.length; i++) {
              if (this.buttonLabels[i] == "Save") {
                this.saveButtonForTraining = true;
                this.trainingData['saveButtonForTraining'] = true;
                this.buttonLabels = this.buttonLabels.filter(obj => { return obj !== "Save" });
                i--;
              }
              if (this.buttonLabels[i] == "Cancel") {
                this.buttonLabels = this.buttonLabels.filter(obj => { return obj !== "Cancel" });
                i--;
              }
            }
          }
          // Ensure updateReason field is visible if we're in edit mode and save is allowed
          if (this.operationFlag === "EDIT" && this.saveButtonForTraining) {
            this.visibleReasonForTrainingUpdateField = true;
          }
        })

    }
  }
  isMeetingUrlInvalid: boolean = false;

  validateMeetingUrl(url: string | undefined): boolean {
    if (!url || url.trim() === '') {
      return true;
    }

    try {
      const parsedUrl = new URL(url.trim());
      if (parsedUrl.protocol !== 'https:') {
        return false;
      }

      const host = parsedUrl.hostname.toLowerCase();
      const isGoogleMeet = host === 'meet.google.com';
      const isZoom = host === 'zoom.us' || host.endsWith('.zoom.us');
      const isTeams = host === 'teams.microsoft.com' || host === 'teams.live.com';

      return isGoogleMeet || isZoom || isTeams;
    } catch (e) {
      return false;
    }
  }

  onMeetingUrlChange() {
    if (this.trainingData.meetingUrl) {
      this.isMeetingUrlInvalid = !this.validateMeetingUrl(this.trainingData.meetingUrl);
    } else {
      this.isMeetingUrlInvalid = false;
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };
  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.trainingImage = file;
      this.trainingData.trainingImageExtn = (file.name.split('.').pop() ?? '').toLowerCase();

      if (this.trainingData.trainingImageExtn != "jpg" && this.trainingData.trainingImageExtn != "png" && this.trainingData.trainingImageExtn != "jpeg") {
        let type = "E";
        let result = this.trainingData.trainingImageExtn + " file type is not allowed. Please upload JPG/JPEG or PNG images only"
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: result,
            type: type == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: type == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {

        // 1. INSTANT LOCAL PREVIEW
        const reader = new FileReader();
        reader.onload = (e: any) => {
          // Extract ONLY the base64 string without the data URL prefix
          const base64String = e.target.result.split(',')[1];
          this.displaytrainingImage = base64String;
          this.clearedTrainingImage = false;

          // Force the UI to reflect the local preview immediately
          this.cd.detectChanges();
        };
        reader.readAsDataURL(file);

        // 2. PROCEED WITH SERVER UPLOAD
        let name = file.name.substring(0, file.name.lastIndexOf('.'));
        let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
        const formData = new FormData();
        formData.append('file', file ?? '');
        formData.append("pageName", "TMS");
        formData.append("fileName", name);
        formData.append("extension", extension);

        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe({
            next: (data: any) => {
              this.isProcessing = false;
              if (data.resultType == "S") {
                this.isFileValid = true;
                this.clearedTrainingImage = false;

                // Let the local FileReader preview persist on the screen.

                this.cd.detectChanges();
              } else {
                this.isFileValid = false;
                this.trainingImage = null;
                this.trainingData.trainingImageExtn = '';
                this.displaytrainingImage = null; // Clear preview if upload fails
                this.cd.detectChanges();

                let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                  duration: 5000,
                  data: {
                    message: data.result,
                    type: data.resultType == 'S' ? 'Success' : 'Error',
                    buttonLabel: "Ok"
                  },
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  panelClass: data.resultType == 'S' ? 'Success' : 'Error',
                });
                sb.onAction().subscribe(() => {
                  sb.dismiss();
                });
              }
            }, error: (error) => {
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              this.displaytrainingImage = null; // Clear preview on error
              this.cd.detectChanges();
              throw error;
            }
          })
      }

    } else {
      this.trainingImage = '';
      this.trainingData.trainingImageExtn = '';
      this.displaytrainingImage = null;
    }
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  warningMsg: any = "";
  taskStagesList: any = [];
  saveTraining() {
    this.selectedTabIndex = 0;
    this.onClickedSaveButton = true;
    if (!this.validateMeetingUrl(this.trainingData.meetingUrl)) {
    this.isMeetingUrlInvalid = true;
    this.warningMsg = "Invalid Meeting URL! Only secure Google Meet, MS Teams, and Zoom links are allowed.";
    this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    this.isProcessing = false;
    return;
  }
    this.isProcessing = true;
    let list = [];
    if (this.operationFlag === "EDIT" &&
      (this.trainingData.updateReason == null || this.trainingData.updateReason.trim() === '')) {
      this.warningMsg = "Please enter update reason!";
      this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
    } else {
      this.isProcessing = false;

      const validations = [
        { condition: (!this.trainingData['trainingName']), id: 'training-name-validation' },
        { condition: (!this.trainingData['trainingCode']), id: 'training-code-validation' },
        { condition: (!this.selectedCategoryValue), id: 'category-validation' },
        { condition: (!this.selectedTrainingTypeValue), id: 'type-validation' },
        { condition: (!this.selectedLanguageValue), id: 'language-validation' }
      ]

      const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

      if (invalidIds.length > 0) {
        this.mandatoryValidation(invalidIds);
        this.warningMsg = "Please enter all mandatory fields!";
        this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      } else {
        if (this.operationFlag == "ADD") {
          this.trainingData['operation'] = "I"
        } else {
          delete this.trainingData['createdOn'];
          delete this.trainingData['updatedOn'];
          this.trainingData['operation'] = "U"
        }

        this.trainingData['categoryCode'] = this.selectedCategoryValue;
        this.trainingData['type'] = this.selectedTrainingTypeValue;
        this.trainingData['language'] = this.selectedLanguageValue;
        this.trainingData['selfAssignable'] = this.trainingData['selfAssignable1'] ? "Y" : "N";

        if (this.trainingData['expiryDate'] !== null) {
          const trainingExpiryDate = new Date(this.trainingData['expiryDate']);
          this.trainingData['expiryDate'] = this.appService.dateZoneConvertion(trainingExpiryDate);
        }
        const formData = new FormData();
        formData.append('file', this.trainingImage);
        const json = JSON.stringify(this.trainingData);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('trainingDto', blob);
        this.isProcessing = true;
        this.appService.addOrUpdateTraining(formData).subscribe({
          next: (Response: any) => {
            this.isProcessing = false;
            if (Response.resultType == "S") {
              this.visibleAddTrainingButton = false;
              this.visibleEditTrainingButton = true;

              if (this.operationFlag == "ADD") {
                this.isProcessing = true;
                this.appService.getTrainingByTrainingIdFirstTime(Response.trainingId).subscribe({
                  next: (data: any) => {
                    this.isProcessing = false;
                    this.trainingData = data[0];

                    this.trainingOperations();
                    this.appService.setTrainingDetails(this.dropDownForCategories, this.trainingData);

                    this.operationFlag = "EDIT";
                  }, error: (error) => {
                    this.isProcessing = false;
                    throw error;
                  }
                });
              } else {
                this.isProcessing = true;
                this.appService.getTrainingByTrainingId(this.trainingData.trainingId,
                  this.trainingData.version).subscribe({
                    next: (data: any) => {
                      this.isProcessing = false;
                      this.trainingData = data[0];
                      this.trainingOperations();

                    }, error: (error) => {
                      this.isProcessing = false;
                      throw error;
                    }
                  });
              }
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  mandatoryValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  back() {
    if (this.trainingData['isFromDashboard']) {
      this.message.breadcrumbData.thirdLevel = null;
      this.router.navigate(['dashboard/MyTasks']);
    } else {
      this.message.breadcrumbData.thirdLevel = null;
      this.router.navigate(['/dashboard/manageTraining/Manage']);
    }

  }

  reason: any;
  title: any;
  warMsg: any;

  buttonLabel: any;

  isEsignRequired = false;
  isReasonSignReqd = false;
  userName: any;
  displayUserName: any;
  password: any = "";
  actionStatus: any;
  comments: any;
  rejectReason: any;
  isConfirmationFileValid = false;
  statusList: CodeList[] = [];
  rejectReasonList: CodeList[] = [];
  reasonForSignatureList: any = [];

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index
  }

  dynamicButtonClick(button: string) {
    this.buttonLabel = button;
    this.changetypeAddAndEditPassword = true;
    if (button == "Obsolete" || button == "Inactivate" || button == "Delete" || button == "Activate" || button == "Update"
      || button == "Self Lock" || button == "Create New Version" || button == "Re-Submit for Review" || button == "Re-Submit for Approval") {
      this.title = button;
      this.reason = null;
      const data = {

        gridName: "TRAINING_CONTENTS"
      }
      this.isProcessing = true;
      this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {

        response.orderByClause ??= "";


        const data1: any = {

          gridName: "TMS_TRAINING_CONTENTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          trainingId: this.trainingData['trainingId'].toString(),
          version: this.trainingData['version'].toString(),
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE" + response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
          this.isProcessing = false;
          let assFlag = 0;
          let contFlag = 0;

          // 1. Loop only to count the flags
          for (let p = 0; p < response1.length; p++) {
            if (response1[p].IS_QUESTION_CONTENT == 'Y') {
              assFlag++;
            }
            if (response1[p].IS_QUESTION_CONTENT == 'N') {
              contFlag++;
            }
          }

          // 2. Evaluate the message and open the dialog OUTSIDE the loop
          if (assFlag > 0 && contFlag == 0) {
            this.warMsg = "Only the assessment has been added. ";
          } else if (assFlag == 0 && contFlag > 0) {
            this.warMsg = "Only the content has been added. ";
          } else if (response1.length === 0) {
            this.warMsg = "No content or assessment has been added. "; // Optional warning for empty content
          } else {
            this.warMsg = "";
          }

          this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
        });
      });

    } else if (button == "Preview") {
      this.router.navigate(['/preview'], {
        state: {
          trainingObj: this.trainingData
        }
      });
    } else if (button == "Review" || button == "Approve") {
      this.password = "";
      this.comments = "";
      this.evidenceFile = null;
      this.buttonOperationFile = null;
      this.clearedOperationDoc = true;
      this.statusDropdown = [];
      this.rejectReasonDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedReason = null;
      this.selectedStatus = [];
      this.selectedRejectReason = null;
      this.selectedReasonValue = "";
      this.selectedStatusValue = "";
      this.selectedRejectReasonValue = "";
      this.reasonDropdown = [];
      this.statusList = [];
      let data1 = [];
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (const element of data1) {
        let data2 = element.split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }

      }
      for (const element of this.statusList) {
        this.statusDropdown = this.statusDropdown.concat({
          valueExp: element.codelistCode,
          displayExp: element.codelistName
        });
      }
      this.isProcessing = true;
      this.appService.getCodeListsByGroup("TRAINING_REJECT_REASON").subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (const element of this.rejectReasonList) {
          this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
            valueExp: element.codelistCode,
            displayExp: element.codelistName
          });
        }
      })
      this.isProcessing = true;
      this.appService.getModuleStages("TRN", this.buttonLabel)
        .subscribe((data: any) => {
          this.isProcessing = false;
          if (data.length > 0) {
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
            if (data[0].reasonForSignatureReqd == "Y") {
              this.isReasonSignReqd = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.title = button;


      const data = {

        gridName: "TRAINING_CONTENTS"
      }
      this.isProcessing = true;
      this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {

        response.orderByClause ??= "";

        const data1: any = {

          gridName: "TMS_TRAINING_CONTENTS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          trainingId: this.trainingData['trainingId'].toString(),
          version: this.trainingData['version'].toString(),
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE" + response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
          this.isProcessing = false;
          let assFlag = 0;
          let contFlag = 0;
          for (let p = 0; p < response1.length; p++) {
            if (response1[p].IS_QUESTION_CONTENT == 'Y') {
              assFlag++;
            }
            if (response1[p].IS_QUESTION_CONTENT == 'N') {
              contFlag++;
            }
            if (p == (response1.length - 1)) {
              if (assFlag > 0 && contFlag == 0) {
                this.warMsg = "Only the assessment has been added. ";
              } else if (assFlag == 0 && contFlag > 0) {
                this.warMsg = "Only the content has been added. ";
              } else {
                this.warMsg = "";
              }
              this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
            }
          }
        });
      });
    }
  }

  fileExtn: any;
  evidenceFile: any = null;
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.evidenceFile = file;
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "TRAINING_OPERATION_DOCUMENT");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              // this.evidenceFile = data.file;
              this.clearedOperationDoc = false;
              this.cd.detectChanges();
            } else {
              this.buttonOperationFile = null;
              this.fileExtn = '';
              this.cd.detectChanges();
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        })
    } else {
      this.buttonOperationFile = '';
      this.fileExtn = '';
    }
  }

  reasonForSignature: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = null;
    this.selectedReasonValue = "";
    this.isProcessing = true;
    let data = {
      stageName: this.buttonLabel,
      status: status,
      module: "TRN",
    }
    this.appService.getReasonForSigns(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.reasonForSignatureList = data;
      for (const element of this.reasonForSignatureList) {
        this.reasonDropdown = this.reasonDropdown.concat({
          valueExp: element.reasonForSignature,
          displayExp: element.reasonForSignature
        });
      }
      if (this.reasonForSignatureList.length == 1) {
        this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

        this.selectedReasonValue = this.reasonForSignatureList[0].reasonForSignature;
        for (const element of this.reasonDropdown) {
          if (element.valueExp == this.reasonForSignatureList[0].reasonForSignature) {
            this.selectedReason = element.valueExp;
          }
        }
      }

    })
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }



  smoothScrollFun(id: any) {
    this.scroller.scrollToAnchor(id);

  }

  previewFunc() {
    this.router.navigate(['/preview'], {
      state: {
        trainingObj: this.trainingData
      }
    });
  }

  omit_special_char(event: any) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == null || this.reason == "") {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else if (this.buttonLabel == "Delete") {
      this.trainingData['deleteReason'] = this.reason;
      delete this.trainingData['createdOn'];
      delete this.trainingData['updatedOn'];
      delete this.trainingData['lockedOn'];
      this.appService.deleteTraining(this.trainingData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.message.breadcrumbData.thirdLevel = null;
          this.router.navigate(['/dashboard/manageTraining/Manage']);
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;

      })
    } else {
      let data = {
        trainingId: this.trainingData['trainingId'],
        version: this.trainingData['version'],
        currentStatus: this.trainingData['status'],
        stageName: this.stageName,
        buttonValue: this.buttonLabel,
        actionStatus: null,
        comments: this.reason,
        rejectReason: null,
        reasonForSignature: null,
        fileExtn: null,
      }
      const formData = new FormData();
      const emptyfile: any = null;
      formData.append('file', emptyfile);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performButtonOperation(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          if (this.buttonLabel == "Create New Version" || this.buttonLabel == "Update") {
            this.isProcessing = true;
            this.appService.getTrainingByTrainingIdFirstTime(this.trainingData.trainingId
            ).subscribe((data: any) => {
              this.isProcessing = false;
              this.trainingData = data[0];
              this.trainingOperations();

            })
          } else {
            this.isProcessing = true;
            this.appService.getTrainingByTrainingId(this.trainingData.trainingId,
              this.trainingData.version).subscribe((data: any) => {
                this.isProcessing = false;
                this.trainingData = data[0];
                this.trainingOperations();

              })
          }

        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }

  }


  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const reasonValidationIcon = document.getElementById('reason-val-icon') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reasonValidationIcon.innerHTML = '';
      reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  selectedCategoryValue: any = "";
  selectedTrainingTypeValue: any = "";
  selectedLanguageValue: any = "";
  selectedRejectReasonValue: any = "";
  selectedStatusValue: any = "";
  selectedReasonValue: any = "";

  onStatusSelect(item: any) {
    this.selectedStatusValue = item;
    this.changetypeAddAndEditPassword = true;
    if (this.selectedStatusValue == "Approver Requested More Info." || this.selectedStatusValue == "Reviewer Requested More Info.") {
      this.isReasonSignReqd = false;
    } else {
      this.statusChanges(this.selectedStatusValue);
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == 'Review Rejected'
      || this.selectedStatusValue == 'Approval Rejected')) {
      this.isShowRejectReason = true;
    } else {
      this.isShowRejectReason = false;
    }
  }
  onStatusRemoved(item: any) {
    this.selectedStatusValue = "";
    this.isShowRejectReason = false;
  }

  onReasonSelect(event: any, item: any) {
    if (event.isUserInput)
      this.selectedReasonValue = item?.valueExp ?? null;
  }

  onReasonSelectOld(item: any) {
    this.selectedReasonValue = item.valueExp;
  }
  onReasonRemoved(item: any) {
    this.selectedReasonValue = "";

  }

  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedRejectReasonValue = item?.valueExp ?? null;
    }
  }

  onRejectReasonSelectOld(item: any) {
    this.selectedRejectReasonValue = item.valueExp;
  }
  onRejectReasonRemoved(item: any) {
    this.selectedRejectReasonValue = "";
  }

  onCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category-validation', item);
      this.selectedCategoryValue = item?.valueExp ?? null;
    }
  }

  onCategorySelectOld(item: any) {
    this.selectedCategoryValue = item.valueExp;
  }

  onCategoryRemoved(item: any) {
    this.selectedCategoryValue = "";
  }

  onTrainingTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('type-validation', item);
      this.selectedTrainingTypeValue = item?.valueExp ?? null;
    }
  }

  onTrainingTypeSelectOld(item: any) {
    this.selectedTrainingTypeValue = item.valueExp;
  }

  onTrainingTypeRemoved(item: any) {
    this.selectedTrainingTypeValue = "";
  }

  onLanguageSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('language-validation', item);
      this.selectedLanguageValue = item?.valueExp ?? null;
    }
  }

  onLanguageSelectOld(item: any) {
    this.selectedLanguageValue = item.valueExp;
  }
  onLanguageRemoved(item: any) {
    this.selectedLanguageValue = "";
  }

  trainingName: any;
  trainingCode: any;
  category: any;
  trainingType: any;
  language: any;
  updateReason: any;

  trainingNameRequiredMsg: any;
  trainingCodeRequiredMsg: any;
  categoryRequiredMsg: any;
  trainingTypeRequiredMsg: any;
  languageRequiredMsg: any;
  updateReasonRequiredMsg: any;
  fieldValidation() {
    this.trainingName = document.getElementById('trainingName') as HTMLInputElement;
    this.trainingCode = document.getElementById('trainingCode') as HTMLInputElement;
    this.category = document.getElementById('category') as HTMLInputElement;
    this.trainingType = document.getElementById('trainingType') as HTMLInputElement;
    this.language = document.getElementById('language') as HTMLInputElement;
    this.updateReason = document.getElementById('reasonForUpdate') as HTMLInputElement;

    this.trainingNameRequiredMsg = document.getElementById('trainingName-required-msg') as HTMLInputElement;
    this.trainingCodeRequiredMsg = document.getElementById('trainingCode-required-msg') as HTMLInputElement;
    this.categoryRequiredMsg = document.getElementById('category-required-msg') as HTMLInputElement;
    this.trainingTypeRequiredMsg = document.getElementById('trainingType-required-msg') as HTMLInputElement;
    this.languageRequiredMsg = document.getElementById('language-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('reasonForUpdate-required-msg') as HTMLInputElement;


    if (this.trainingData.trainingName == "") {
      this.trainingName.style.border = '1px solid red';
      this.trainingNameRequiredMsg.style.display = 'block';
    } else {
      this.trainingName.style.border = 'none';
      this.trainingNameRequiredMsg.style.display = 'none';
    }

    if (this.trainingData.trainingCode == "") {
      this.trainingCode.style.border = '1px solid red';
      this.trainingCodeRequiredMsg.style.display = 'block';
    } else {
      this.trainingCode.style.border = 'none';
      this.trainingCodeRequiredMsg.style.display = 'none';
    }

    if (this.selectedCategoryValue == "") {
      this.category.style.border = '1px solid red';
      this.categoryRequiredMsg.style.display = 'block';
    } else {
      this.category.style.border = 'none';
      this.categoryRequiredMsg.style.display = 'none';
    }

    if (this.selectedTrainingTypeValue == "") {
      this.trainingType.style.border = '1px solid red';
      this.trainingTypeRequiredMsg.style.display = 'block';
    } else {
      this.trainingType.style.border = 'none';
      this.trainingTypeRequiredMsg.style.display = 'none';
    }

    if (this.selectedLanguageValue == "") {
      this.language.style.border = '1px solid red';
      this.languageRequiredMsg.style.display = 'block';
    } else {
      this.language.style.border = 'none';
      this.languageRequiredMsg.style.display = 'none';
    }

    if (this.visibleEditTrainingButton) {
      if (this.trainingData.updateReason == "") {
        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReason.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }
  }

  isSelfAssignedFunction(isTagged: boolean) {
    this.isSelfAssignToggleBoxValue = isTagged;
  }

  isShowDateField = true;
  isExpiryDateChecked(isChecked: boolean) {
    this.trainingData.intimateExpiryBeforeInDays = null;
    if (isChecked) {
      this.isShowDateField = false;
      this.trainingData['expiryDate'] = null;
    } else {
      this.isShowDateField = true;
      this.trainingData['expiryInDays'] = null;
    }
  }

  removeImage() {
    this.clearedTrainingImage = true;
    this.trainingImage = null;
    this.displaytrainingImage = null;
    this.trainingData['trainingImage'] = null;
    this.trainingData['trainingImageExtn'] = "";
  }

  removeOperationDoc() {
    this.clearedOperationDoc = true;
    this.evidenceFile = null;
    this.fileExtn = null;
    this.buttonOperationFile = null;
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }

  buttonOperationFile: any;

  confirmOkFunc() {
    this.isProcessing = true;
    let data = {
      trainingId: this.trainingData['trainingId'],
      version: this.trainingData['version'],
      currentStatus: this.trainingData['status'],
      stageName: this.stageName,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      comments: null,
      rejectReason: null,
      reasonForSignature: null,
    }
    const formData = new FormData();
    formData.append('file', this.buttonOperationFile);
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('object', blob);
    this.appService.performButtonOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      this.visibleConfirm.close();
      if (Response.resultType == "S") {

        this.isProcessing = true;
        this.appService.getTrainingByTrainingId(this.trainingData.trainingId,
          this.trainingData.version).subscribe((data: any) => {
            this.isProcessing = false;
            this.trainingData = data[0];
            this.trainingOperations();

          })
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }


  performButtonOperationForsace(formData: FormData) {
    this.appService.performButtonOperation(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();
        this.isProcessing = true;
        this.appService.getTrainingByTrainingId(this.trainingData.trainingId,
          this.trainingData.version).subscribe((data: any) => {
            this.isProcessing = false;
            this.trainingData = data[0];
            this.trainingOperations();

          })
        this.router.navigate(['/dashboard/manageTraining/Manage']);
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }


  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == "reviewAuthenable") {
              let data = {
                trainingId: this.trainingData['trainingId'],
                version: this.trainingData['version'],
                currentStatus: this.trainingData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForsace(formData)
            }
            this.isProcessing = false;


          } else {
            this.isProcessing = false;

          }

        },
        error: (error) => {
          this.isProcessing = false;

        }
      });



  }

  confirmWithDataFunc() {
    this.isProcessing = true;

    if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "") || (this.isReasonSignReqd && this.selectedReasonValue == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        this.authEnable("reviewAuthenable");

      }
    } else if (!this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "") || (this.isReasonSignReqd && this.selectedReasonValue == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          trainingId: this.trainingData['trainingId'],
          version: this.trainingData['version'],
          currentStatus: this.trainingData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
        }
        const formData = new FormData();
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.performButtonOperationForsace(formData);
      }
    } else if (this.isEsignRequired) {
      if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
              this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "" || this.selectedRejectReasonValue == null) || (this.isReasonSignReqd && this.selectedReasonValue == "")) {
              this.buttonOperationFieldValidation();
              this.isProcessing = false;
            } else {
              let data = {
                trainingId: this.trainingData['trainingId'],
                version: this.trainingData['version'],
                currentStatus: this.trainingData['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatusValue,
                comments: this.comments,
                rejectReason: this.selectedRejectReasonValue,
                reasonForSignature: this.selectedReasonValue,
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('object', blob);
              this.performButtonOperationForsace(formData);
            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedStatusValue == "" || (this.rejectReasonList.length > 0 && (this.selectedReasonValue == "Review Rejected" ||
        this.selectedStatusValue == "Approval Rejected") && this.selectedRejectReasonValue == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          trainingId: this.trainingData['trainingId'],
          version: this.trainingData['version'],
          currentStatus: this.trainingData['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatusValue,
          comments: this.comments,
          rejectReason: this.selectedRejectReasonValue,
          reasonForSignature: this.selectedReasonValue,
          fileExtn: this.fileExtn,
        }
        const formData = new FormData();
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('object', blob);
        this.appService.performButtonOperation(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.visibleConfirmWithData.close();
            this.isProcessing = true;
            this.appService.getTrainingByTrainingId(this.trainingData['trainingId'],
              this.trainingData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.trainingData = data[0];
                this.trainingOperations();

              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      }
    }
  }

  isShowRejectReason = false;

  status: any;
  pass: any;
  rejectReason1: any;
  reasonForSignature1: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  rejectReasonRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.rejectReason1 = document.getElementById('rejectReason') as HTMLInputElement;
    this.reasonForSignature1 = document.getElementById('reasonForSignature') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.rejectReasonRequiredMsg = document.getElementById('rejectReason-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;


    if (this.selectedStatusValue == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }

    if (this.password == "") {
      this.pass.style.border = '1px solid red';
      this.passRequiredMsg.style.display = 'block';
    } else {
      this.pass.style.border = 'none';
      this.passRequiredMsg.style.display = 'none';
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatusValue == "Review Rejected" ||
      this.selectedStatusValue == "Approval Rejected")) {
      if (this.selectedRejectReasonValue == "") {
        this.rejectReason1.style.border = '1px solid red';
        this.rejectReasonRequiredMsg.style.display = 'block';
      } else {
        this.rejectReason1.style.border = 'none';
        this.rejectReasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.isReasonSignReqd) {
      if (this.selectedReasonValue == "") {
        this.reasonForSignature1.style.border = '1px solid red';
        this.reasonForSignatureRequiredMsg.style.display = 'block';
      } else {
        this.reasonForSignature1.style.border = 'none';
        this.reasonForSignatureRequiredMsg.style.display = 'none';
      }
    }
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  openTopicPopup() {
    this.message.communicatingFrom = "TRN";
    let data = {
      trainingId: this.trainingData.trainingId,
      version: this.trainingData.version,
    }
    this.message.serviceFromTrainingsForCommunication = data;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  canceltopicPopup() {
    this.visibleTopicPopup.close();
  }

  okInfo() {
    this.visibleInfoPopup.close();
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  auditTrail() {
    this.message.tableOrView_Name = "TMS_TRAININGS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,TRAINING_CODE,TRAINING_NAME,CATEGORY_CODE,LANGUAGE,VERSION,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,STATUS,DESCRIPTION,TOTAL_DURATION,SELF_ASSIGNABLE,EXPIRY_DATE,EXPIRY_IN_DAYS,TRAINING_IMAGE,TRAINING_IMAGE_EXTN,INTIMATE_EXPIRY_BEFORE_IN_DAYS,LOCKED_BY_USER,LOCKED_FOR,LOCKED_ON,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Training Code,Training Name,Category,Language,Version,Is Latest Version,Is Latest Published Version,Status,Description,Total Duration,Self Assignable,Expiry Date,Expiry in Days,Training Image,Training Image Extension,Intimate Expiry Before In Days,Self Locked By,Self Lock Comment,Self Locked On,Created On,Created By,Updated On,Updated By,Update Reason";
    this.message.whereClause_AU = " AND TRAINING_ID=" + this.trainingData.trainingId + " AND VERSION=" + this.trainingData.version;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Training Code,Training Name,Category,Language,Version,Is Latest Version,Is Latest Published Version,Status,Description,Total Duration,Self Assignable,Expiry Date,Expiry in Days,Training Image,Training Image Extension,Intimate Expiry Before In Days,Self Locked By,Self Lock Comment,Self Locked On,Created On,Created By,Updated On,Updated By,Update Reason";
    this.message.whereClause_Report = " WHERE TRAINING_ID=" + this.trainingData.trainingId + " AND VERSION=" + this.trainingData.version;
    this.message.report_And_Popup_Name = 'Training Details Audit Trail [' + this.trainingData.trainingName + ' V-' + this.trainingData.version + ']';
    this.staticAuditTrailComponent.triggerTrail(this.trainingData);
  }

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_TRAININGS_VW";
    this.excelPdf.columnList_DB = "TRAINING_CODE,TRAINING_NAME,CATEGORY_CODE,LANGUAGE,VERSION,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,STATUS,DESCRIPTION,TOTAL_DURATION,SELF_ASSIGNABLE,EXPIRY_DATE,EXPIRY_IN_DAYS,TRAINING_IMAGE_EXTN,INTIMATE_EXPIRY_BEFORE_IN_DAYS,LOCKED_BY_USER,LOCKED_FOR,LOCKED_ON,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Training Code,Training Name,Category,Language,Version,Is Latest Version,Is Latest Published Version,Status,Description,Total Duration,Self Assignable,Expiry Date,Expiry in Days,Training Image Extension,Intimate Expiry Before In Days,Self Locked By,Self Lock Comment,Self Locked On,Created On,Created By,Updated On,Updated By,Update Reason";
    this.excelPdf.whereClause_Report = " WHERE TRAINING_ID=" + this.trainingData.trainingId + " AND VERSION=" + this.trainingData.version;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Training Details Report [' + this.trainingData.trainingName + ' V-' + this.trainingData.version + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdf.manualEntryDataFields = "EFFECTIVE_DATE,EXPIRATION_DATE";
    this.excelPdfComponent.openReportPopup(reportType);
  }

  checkWarning() {
    if (this.trainingData.expiryDate != null) {
      const date: any = new Date(this.trainingData.expiryDate);
      const today: any = new Date();
      const difference = Math.round((date - today) / (1000 * 60 * 60 * 24));

      if (this.trainingData.intimateExpiryBeforeInDays > difference) {
        this.trainingData.expiryDate = null;
        this.trainingData.expiryInDays = null;
        this.trainingData.intimateExpiryBeforeInDays = null;

        this.cd.detectChanges(); // 🔥 FORCE UI UPDATE

        this.warningMsg = "Intimate expiry before days are greater than expiry Days";
        this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      }

    } else if (this.trainingData.expiryInDays != null) {

      if (this.trainingData.intimateExpiryBeforeInDays > this.trainingData.expiryInDays) {
        this.trainingData.expiryDate = null;
        this.trainingData.expiryInDays = null;
        this.trainingData.intimateExpiryBeforeInDays = null;
        this.cd.detectChanges(); // 🔥 FORCE UI UPDATE

        this.warningMsg = "Intimate expiry before days are greater than expiry Days";
        this.visibleInfoPopup = this.dialog.open(this.infoPopup, this.infoPopupConfig);
      }
    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isBusinessOrRootCauseValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isBusinessOrRootCauseValidation ? !selectedItems.length : !selectedItems;

    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }
}
